var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature"},[_c('div',{staticClass:"feature_icon"},[_c('div',{staticClass:"feature_icon_bg",style:(_vm.getColorStyle)}),_vm._v(" "),_c('img',{attrs:{"src":_vm.img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"feature_title"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.title)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }